import { ClientLocation } from '../clients-module/models/clientLocation';

export class FileTransferPayload {
    userId : number;
    clientId : number;
    clientName: string;
    base64FileString : string;
    locations : ClientLocation[];
    screeningId : number;
    inviteId : number;
    packageId: number;
    screeningDraftId : number;
    fileName : string;
    uploadType: BatchUploadType;
    
}

export enum BatchUploadType {
    User = 0,
    Screening
}